import {createSlice} from "@reduxjs/toolkit";

let v = {
  sidebarShow: true,
  asideShow: false,
  theme: 'default',
}
try {
  let vv = JSON.parse(localStorage.getItem('default'));
  if (vv) {
    v = vv;
  }
} catch (e) {
}

const slice = createSlice({
    name: "default",
    initialState: v,
    reducers: {
      set: (state, action) => {
        state[action.payload.name] = action.payload.value;
        localStorage.setItem('default', JSON.stringify(state));
        return state;
      }
    }
  })
;

export const {set} = slice.actions;

export default slice.reducer;
